module.exports = __webpack_public_path__ + "assets/img/front.934e555a.png";